import { appendQsParams, get } from 'lib/request';

export const getSelectionOffersList = async ({ after, slug, limit }, opts) =>
  get(appendQsParams(`/selections/${slug}/offers`, { after, limit }), opts);

export const getSelectionInfo = async ({ selectionSlug }) =>
  get(`/v4/selections/${selectionSlug}`);
